import { type Metric } from '../vessel_data'

export enum WaterMarkerMetric {
  watermaker1 = 'watermaker1',
  watermaker2 = 'watermaker2',
  watermaker3 = 'watermaker3',
}

export type WatermakerMetricName = keyof typeof WaterMarkerMetric

export type WatermakerMetrics = Record<WatermakerMetricName, Metric>

export const allWaterMakerMetricNames: WatermakerMetricName[] = Object.values(WaterMarkerMetric)
